/** login-popup-redirect の永続コンテキストを有効とみなす期限 */
export const LOGIN_POPUP_REDIRECT_TTL_MS = 30 * 60 * 1000

/**
 * ログイン失敗のうち「新規登録として再試行しても解決しない」エラーコード。
 * これ以外（未知のコードを含む）は未登録の可能性があるものとして登録へ回す。
 */
export const SIGNUP_RETRY_BLOCKED_ERROR_CODES = [
  'auth/user-disabled',
  'auth/too-many-requests',
  'auth/network-request-failed',
  'auth/operation-not-allowed',
  'auth/invalid-email'
]

/** Mail Link login setting */
export const actionCodeSettings = {
  url: process.env.VUE_APP_SITE_URL as string,
  handleCodeInApp: true
}

export const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'

/** バックアップ対象（'yagiProfile' は端末ごとに持たせるため除外） */
export const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'format_letter',
  'format_etc',
  'format_taishokutodoke',
  'basicData',
  'recentEdit',
  LAST_SAVE_DATE_SAVE_KEY
]

export const SITE_ID = process.env.VUE_APP_SITE_ID as string

export type FirestorePaths = {
  userdata: string
  userDoc: string
  backups: string
  configs: string
  omikujis: string
  postcards: string
  statistics: string
  statisticsOmikuji: string
  lightdata: string
  omikujiDoc?: string
}

export function createFirestorePaths(
  uid: string,
  docId?: string
): FirestorePaths | Record<string, never> {
  if (!uid) {
    console.error('uid not set')
    return {}
  }
  const paths: FirestorePaths = {
    userdata: 'userdata',
    userDoc: `userdata/${uid}`,
    backups: `userdata/${uid}/backups`,
    configs: `userdata/${uid}/configs`,
    omikujis: `userdata/${uid}/omikujis`,
    postcards: `userdata/${uid}/postcards`,
    statistics: `serverdata/${uid}/statistics`,
    statisticsOmikuji: `serverdata/${uid}/statistics/omikuji`,
    lightdata: `users/${uid}`
  }
  if (docId) {
    paths.omikujiDoc = `userdata/${uid}/omikujis/${docId}`
  }
  return paths
}

export const CONFIG_DOCUMENT_ID = process.env.VUE_APP_SITE_ID as string
export const DEFAULT_QUERY_LIMIT_NUM = 10
export const BACKUP_QUERY_LIMIT_NUM = 10
export const BACKUP_SAVE_LIMIT_NUM = 50
const AUTO_BACKUP_INTERVAL_SECONDS = 60
export const AUTO_BACKUP_INTERVAL_MS = AUTO_BACKUP_INTERVAL_SECONDS * 1000
